import { render, staticRenderFns } from "./SceneManager.vue?vue&type=template&id=509ae4e0&"
import script from "./SceneManager.vue?vue&type=script&lang=js&"
export * from "./SceneManager.vue?vue&type=script&lang=js&"
import style0 from "./SceneManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports